import { Dropdown, MenuItem } from 'react-bootstrap';
import React from 'react';
import { SidebarSearch } from 'components/search_sidebar/sidebar_search';
import PropTypes from 'prop-types';

export default function TagTopBar({
  handleTagSearch,
  openDeleteTagsModal,
  openMergeTagsModal,
  openNewTagModal,
  searchValue,
  selectedTagsLength
}) {
  return (
    <div>
      <ul className="list-inline pt-3">
        <li className="pl-25 w-50">
          <SidebarSearch
            name="search_text"
            placeholder="Search current tags"
            value={searchValue}
            onChange={handleTagSearch}
          />
        </li>
        <li className="pull-right pt-0">
          <div className="btn-group dropdown">
            <Dropdown className="actions-dropdown" id="actions-dropdown">
              <Dropdown.Toggle>
                Actions
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <MenuItem disabled={selectedTagsLength < 2} key="merge-records" onClick={openMergeTagsModal}>Merge
                  Tags</MenuItem>
                <MenuItem disabled={selectedTagsLength < 1} key="delete-group" onClick={openDeleteTagsModal}>Delete
                  Tags</MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <button
            className="btn btn-create left-buffer-md"
            onClick={openNewTagModal}
          >
            + Add New
          </button>
        </li>
      </ul>
    </div>
  );
}

TagTopBar.propTypes = {
  handleTagSearch: PropTypes.func.isRequired,
  openDeleteTagsModal: PropTypes.func.isRequired,
  openMergeTagsModal: PropTypes.func.isRequired,
  openNewTagModal: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  selectedTagsLength: PropTypes.number.isRequired
};
